import { Box, styled, Theme } from '@mui/material';
import { lighten } from '@mui/material/styles';

interface HeroGradientStyledProps {
  secondarycolor: string;
}

export const ForegroundImageStyled = styled('img')<{
  className?: string;
  theme: Theme;
}>(() => ({
  objectPosition: 'top',
  objectFit: 'cover',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  position: 'absolute',
  zIndex: 1,
}));
export const HeroGradientStyled = styled(Box)<HeroGradientStyledProps>(
  ({ theme: Theme, secondarycolor }) => ({
    background: `linear-gradient(101deg, ${lighten(Theme.palette.secondary.main, 0.7)} 19.74%, ${lighten(secondarycolor, 0.7)} 93.02%)`,

    width: '100%',
    height: '100%',
    zIndex: 0,
    position: 'absolute',
  })
);
